import { Factory } from 'miragejs';

export default Factory.extend({
  autoApproved: false,
  reviewNote: 'Much approval, Very Status',
  reviewerName: 'Doge',
  status: 'review',
});
